import { lazy } from 'react';
import { NoContentPage } from '../components/shared';
import { root } from '../containers/shared/auth/rules';

const AsyncLanding = lazy(() => import('../containers/shared/landing'));

// exports
const AsyncMetabaseDataExport = lazy(() => import('../containers/shared/export'));
const AsyncMetabaseDataExportQuestion = lazy(() => import('../containers/shared/export/Question'));
const AsyncExport = lazy(() => import('../containers/shared/export/AttributeExportDashboard'));
const AsyncProgrammeStats = lazy(() => import('../containers/shared/export/ProgrammeStatsDashboard'));

const AsyncDashboards = lazy(() => import('../containers/shared/dashboard'));
const AsyncReportingRequirements = lazy(() => import('../containers/shared/reportingRequirements'));
const AsyncReportingRequirementDetail = lazy(() =>
  import('../containers/shared/reportingRequirements/RequirementDetail')
);
const AsyncDashboardsDashboard = lazy(() => import('../containers/shared/dashboard/Dashboard'));
const AsyncDashboardsUsers = lazy(() => import('../containers/shared/dashboard/DashboardUsers'));
const AsyncInsightUsers = lazy(() => import('../containers/shared/insights/InsightUsers'));
const AsyncDashboardsMetabase = lazy(() => import('../containers/shared/dashboard/Metabase'));
const AsyncNewDashboardLayout = lazy(() => import('../containers/shared/dashboard/newDashboardLayout'));

const AsyncInstitutions = lazy(() => import('../containers/shared/institutions'));
const AsyncInstitutionDetails = lazy(() => import('../containers/shared/institutions/InstitutionDetails'));
const AsyncInstitutionCohorts = lazy(() => import('../containers/shared/institutions'));
const AsyncInstitutionCohortDetails = lazy(() => import('../containers/shared/institutions/CohortDetails'));
const AsyncInstitutionRegistrations = lazy(() => import('../containers/shared/institutions'));
const AsyncArchivedInstitutions = lazy(() => import('../containers/institution/institutions/AllArchivedInstitutions'));
const AsyncECDServiceDetails = lazy(() => import('../containers/institution/institutions/ECDService/Details'));
const AsyncECDServiceContacts = lazy(() => import('../containers/institution/institutions/ECDService/Contacts'));
const AsyncECDServiceRegistrationManagement = lazy(() =>
  import('../containers/institution/institutions/ECDService/Registration')
);
const AsyncECDRegistrations = lazy(() => import('../containers/institution/institutions/AllEcds'));
const AsyncECDApplication = lazy(() => import('../containers/institution/institutions/ecdRegistration/application'));
const AsyncECDFramework = lazy(() => import('../containers/institution/institutions/ecdRegistration/framework'));
const AsyncECDApproval = lazy(() => import('../containers/institution/institutions/ecdRegistration/approval'));
const AsyncECDAssessment = lazy(() => import('../containers/institution/institutions/ecdRegistration/assessment'));
const AsyncECDComplete = lazy(() => import('../containers/institution/institutions/ecdRegistration/complete'));

const AsyncPeople = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleProfileDetails = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncAddPeopleTable = lazy(() => import('../containers/shared/peopleProfiles/forms/PersonDetails'));
const AsyncPeopleCohorts = lazy(() => import('../containers/shared/peopleProfiles'));
const AsyncPeopleCohortDetails = lazy(() => import('../containers/shared/peopleProfiles/CohortDetails'));

const AsyncSPTemplates = lazy(() => import('../containers/serviceProvider/templates/AllSPTemplates'));
const AsyncSPTemplateDetails = lazy(() => import('../containers/serviceProvider/templates/template'));

const AsyncActivitiesDetails = lazy(() => import('../containers/shared/activities/ActivitiesDetails'));
const AsyncManageActivitiesDetails = lazy(() => import('../containers/shared/activities/ManageActivitiesDetails'));
const AsyncManageGroupOptions = lazy(() => import('../containers/shared/activities/groups/options'));

const AsyncActivitiesSessions = lazy(() => import('../containers/shared/sessions'));
const AsyncActivitiesSessionsCreate = lazy(() => import('../containers/shared/sessions/forms/CreateForm'));

const AsyncTeamMembers = lazy(() => import('../containers/serviceProvider/teamMembers'));
const AsyncTeamMembersCreate = lazy(() => import('../containers/serviceProvider/teamMembers/forms/CreateForm'));
const AsyncActivitiesAttendees = lazy(() => import('../containers/shared/activities/forms/ActivityAttendeesForm'));
const AsyncActivityForm = lazy(() => import('../containers/shared/activities/forms/ActivityForm'));
const AsyncActivityAssignUsers = lazy(() => import('../containers/shared/activities/forms/ActivityAssignUsers'));

const AsyncReports = lazy(() => import('../containers/shared/reports'));
const AsyncReportDetails = lazy(() => import('../containers/shared/reports/Details'));

const AsyncProfile = lazy(() => import('../containers/shared/profile'));
// Insights
const AsyncInsights = lazy(() => import('../containers/shared/insights/AllInsights'));
const AsyncInsightsEmbedFrame = lazy(() => import('../containers/shared/insights/InsightsEmbedReport'));
const AsyncManageInsights = lazy(() => import('../containers/serviceProvider/Insights'));
const AsyncInsightsDetails = lazy(() => import('../containers/serviceProvider/Insights/forms/Details'));

// admin
const AsyncAdminPage = lazy(() => import('../containers/shared/admin'));
const AsyncAccountDetails = lazy(() => import('../containers/serviceProvider/account'));
const AsyncAdminWorkspaceCreate = lazy(() => import('../containers/serviceProvider/admin/workspace/CreateForm'));
const AsyncAdminWorkspaceOverview = lazy(() => import('../containers/shared/admin/overview'));
const AsyncAdminWorkspaceDatasetCreate = lazy(() => import('../containers/shared/admin/datasets/Dataset'));
const AsyncAdminWorkspaceFormCreate = lazy(() => import('../containers/shared/admin/forms/CreateForm'));
const AsyncAdminModules = lazy(() => import('../containers/shared/admin/modules'));
const AsyncAdminAuditTrail = lazy(() => import('../containers/shared/admin/auditTrail'));
const AllWorkspaces = lazy(() => import('../containers/serviceProvider/admin/workspace'));
const AsyncAdminOrganisations = lazy(() => import('../containers/shared/admin/organisations'));
const AsyncAdminOrganisationsUsers = lazy(() => import('../containers/shared/admin/organisations/users'));

// programme / portfolio / interventions
const AsyncProgramme = lazy(() => import('../containers/shared/programmes'));
const AsyncProgrammeOverview = lazy(() => import('../containers/shared/programmes/overview'));
const AsyncProgrammeIndicators = lazy(() => import('../containers/shared/programmes/indicators'));
const AsyncProgrammeMonitoring = lazy(() => import('../containers/shared/programmes/monitoring'));
const AsyncProgrammeComplete = lazy(() => import('../containers/shared/programmes/summary'));
const AsyncProgrammeSites = lazy(() => import('../containers/shared/programmes/sites'));
const AsyncProgrammeHierarchies = lazy(() => import('../containers/shared/programmes/sites/hierarchies'));
const AsyncProgrammeHierarchy = lazy(() => import('../containers/shared/programmes/sites/hierarchies/hierarchy'));
const AsyncProgrammeServices = lazy(() => import('../containers/shared/programmes/sites/services'));
const AsyncProgrammeService = lazy(() => import('../containers/shared/programmes/sites/services/service'));
const AsyncProgrammeReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncProgrammeReporterAssignees = lazy(() => import('../containers/shared/programmes/reporters/assignees'));
const AsyncInterventionOverview = lazy(() => import('../containers/shared/interventions/overview'));
const AsyncInterventionIndicators = lazy(() => import('../containers/shared/interventions/indicators'));
const AsyncInterventionInputs = lazy(() => import('../containers/shared/interventions/inputs'));
const AsyncInterventionActivities = lazy(() => import('../containers/shared/interventions/activities'));
const AsyncInterventionMonitoring = lazy(() => import('../containers/shared/interventions/monitoring'));
const AsyncInterventionComplete = lazy(() => import('../containers/shared/interventions/complete'));
const AsyncInterventionStakeholderCohorts = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholders = lazy(() => import('../containers/shared/interventions/stakeholders'));
const AsyncInterventionStakeholderCohortDetails = lazy(() =>
  import('../containers/shared/interventions/stakeholders/CohortDetails')
);
const AsyncInterventionInstitutionCohorts = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutions = lazy(() => import('../containers/shared/interventions/institutions'));
const AsyncInterventionInstitutionCohortDetails = lazy(() =>
  import('../containers/shared/interventions/institutions/CohortDetails')
);

// My Forms
const AsyncMyFormsPage = lazy(() => import('../containers/shared/myForms'));
const AsyncMyFormsSubmissionPage = lazy(() => import('../containers/shared/myForms/submissions/CreateForm'));
const AsyncMyFormsCreateSubmission = lazy(() => import('../containers/shared/myForms/submissions/CreateSubmission'));
const AsyncMyFormsSubmissionCalculate = lazy(() => import('../containers/shared/myForms/submissions/Calculate'));

// Indicators
const AsyncIndicators = lazy(() => import('../containers/shared/indicatorFrameworks/pages'));
const AsyncIndicatorPeriods = lazy(() => import('../containers/shared/indicatorFrameworks/pages/IndicatorPeriods'));
const AsyncIndicatorFrameworks = lazy(() => import('../containers/shared/indicatorFrameworks'));
const AsyncIndicatorFrameworkMonitoring = lazy(() => import('../containers/shared/indicatorFrameworks/monitoring'));
const AsyncIndicatorFrameworkReporters = lazy(() => import('../containers/shared/programmes/reporters'));
const AsyncIndicatorFrameworkReportersAssignees = lazy(() =>
  import('../containers/shared/programmes/reporters/assignees')
);
const AsyncIndicatorFrameworkPeriodGroups = lazy(() => import('../containers/shared/periodGroups'));
const AsyncIndicatorFrameworkPeriodGroupPeriods = lazy(() =>
  import('../containers/shared/periodGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroupPeriods = lazy(() =>
  import('../containers/shared/currencyGroups/IndicatorPeriods')
);
const AsyncIndicatorFrameworkCurrencyGroups = lazy(() => import('../containers/shared/currencyGroups'));

// My Cases
const AsyncMyCases = lazy(() => import('../containers/shared/cases'));
const AsyncClientPage = lazy(() => import('../containers/shared/cases/ClientPage'));
const AsyncConsultationPage = lazy(() => import('../containers/shared/cases/ConsultationPage'));
const AsyncCaseManagement = lazy(() => import('../containers/shared/cases/CaseManagement'));
const AsyncConfigureSession = lazy(() => import('../containers/shared/cases/ConfigureSession'));
const AsyncCaseIdConfiguration = lazy(() => import('../containers/shared/cases/CaseManagement/CaseIdConfiguration'));
const AsyncCaseDetailsConfiguration = lazy(() =>
  import('../containers/shared/cases/CaseManagement/CaseDetailsConfiguration')
);
const AsyncCaseSummaryConfiguration = lazy(() =>
  import('../containers/shared/cases/CaseManagement/CaseSummaryConfiguration')
);

export const serviceProviderRoutes = [
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboard', path: '/service-provider' },
    ],
    exact: true,
    path: '/service-provider',
    component: AsyncLanding,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Insights', path: '/service-provider/insights' },
    ],
    exact: true,
    path: '/service-provider/insights',
    component: AsyncInsights,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Insights', path: '/service-provider/insights' },
    ],
    exact: true,
    path: '/service-provider/insights/:insightType/:insightId',
    component: AsyncInsightsEmbedFrame,
  },
  {
    breadcrumbs: [{ title: 'Home', path: '/service-provider/my-profile' }],
    exact: true,
    path: '/service-provider/my-profile',
    component: AsyncProfile,
  },

  // config
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Configure Dashboard', path: '/service-provider/config/dashboard' },
    ],
    exact: true,
    path: '/service-provider/config/dashboard',
    component: NoContentPage,
  },

  // management
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites',
    component: AsyncInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/service-provider/manage/institutions/sites/hierarchies' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/service-provider/manage/institutions/sites/hierarchies' },
      { title: 'Hierarchy', path: '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Hierarchies', path: '/service-provider/manage/institutions/sites/hierarchies' },
      { title: 'Create', path: '/service-provider/manage/institutions/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Services', path: '/service-provider/manage/institutions/sites/services' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Services', path: '/service-provider/manage/institutions/sites/services' },
      { title: 'Service', path: '/service-provider/manage/institutions/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Sites', path: '/service-provider/manage/institutions/sites' },
      { title: 'Services', path: '/service-provider/manage/institutions/sites/services' },
      { title: 'Create', path: '/service-provider/manage/institutions/sites/services/create' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Cohorts', path: '/service-provider/manage/institutions/cohorts' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/cohorts',
    component: AsyncInstitutionCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations',
    component: AsyncInstitutionRegistrations,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/archived',
    component: AsyncArchivedInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/create',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/service-details', // only for ECD Services
    component: AsyncECDServiceDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/service-contacts', // only for ECD Services
    component: AsyncECDServiceContacts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/registration-management', // only for ECD Services
    component: AsyncECDServiceRegistrationManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'ECD Registrations',
        path: '/service-provider/manage/institutions/registrations/:institutionId/registrations',
      },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/registrations',
    component: AsyncECDRegistrations,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'ECD Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'Registration Progress',
        path: '/service-provider/manage/institutions/registrations/:institutionId/registrations',
      },
      {
        title: 'New Registration',
        path: '/service-provider/manage/institutions/registrations/:institutionId/registrations/register',
      },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/registrations/register',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'ECD Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'Application',
        path:
          '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application',
      },
    ],
    exact: true,
    path:
      '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application',
    component: AsyncECDApplication,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'ECD Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'Framework',
        path:
          '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework',
      },
    ],
    exact: true,
    path:
      '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework',
    component: AsyncECDFramework,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'ECD Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'Assessment',
        path:
          '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment',
      },
    ],
    exact: true,
    path:
      '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment',
    component: AsyncECDAssessment,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'ECD Registrations', path: '/service-provider/manage/institutions/registrations' },
      {
        title: 'Complete',
        path:
          '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete',
      },
    ],
    exact: true,
    path:
      '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete',
    component: AsyncECDComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Registrations', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/approve',
    component: AsyncECDApproval,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/institutions/registrations' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/people',
    component: AsyncPeople,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/institution' },
      {
        title: 'People',
        path: '/service-provider/manage/institutions/registrations/:institutionId/people',
      },
      {
        title: 'Create',
        path: '/service-provider/manage/institutions/registrations/:institutionId/people/create',
      },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/people/create',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      {
        title: 'People',
        path: '/service-provider/manage/institutions/registrations/:institutionId/people',
      },
      {
        title: 'Edit',
        path: '/service-provider/manage/institutions/registrations/:institutionId/people/:personId',
      },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/registrations/:institutionId/people/:personId',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Create', path: '/service-provider/manage/institutions/create' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/create',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Edit', path: '/service-provider/manage/institutions/:institutionId' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/:institutionId',
    component: AsyncInstitutionDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Cohorts', path: '/service-provider/manage/institutions/cohorts' },
      { title: 'Create', path: '/service-provider/manage/institutions/cohorts/create' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/cohorts/create',
    component: AsyncInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Institutions', path: '/service-provider/manage/institutions' },
      { title: 'Cohorts', path: '/service-provider/manage/institutions/cohorts' },
      { title: 'Edit', path: '/service-provider/manage/institutions/cohorts/:cohortId' },
    ],
    exact: true,
    path: '/service-provider/manage/institutions/cohorts/:cohortId',
    component: AsyncInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
    ],
    exact: true,
    path: '/service-provider/manage/people',
    component: AsyncPeople,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Cohorts', path: '/service-provider/manage/people/cohorts' },
    ],
    exact: true,
    path: '/service-provider/manage/people/cohorts',
    component: AsyncPeopleCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Create', path: '/service-provider/manage/people/create' },
    ],
    exact: true,
    path: '/service-provider/manage/people/create',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Add New', path: '/service-provider/manage/people/addnew' },
    ],
    exact: true,
    path: '/service-provider/manage/people/addnew',
    component: AsyncAddPeopleTable,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Edit', path: '/service-provider/manage/people/:personId' },
    ],
    exact: true,
    path: '/service-provider/manage/people/:personId',
    component: AsyncPeopleProfileDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Cohorts', path: '/service-provider/manage/people/cohorts' },
      { title: 'Create', path: '/service-provider/manage/people/cohorts/create' },
    ],
    exact: true,
    path: '/service-provider/manage/people/cohorts/create',
    component: AsyncPeopleCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'People', path: '/service-provider/manage/people' },
      { title: 'Cohorts', path: '/service-provider/manage/people/cohorts' },
      { title: 'Edit', path: '/service-provider/manage/people/cohorts/:cohortId' },
    ],
    exact: true,
    path: '/service-provider/manage/people/cohorts/:cohortId',
    component: AsyncPeopleCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Templates', path: '/service-provider/manage/templates' },
    ],
    exact: true,
    path: '/service-provider/manage/templates',
    component: AsyncSPTemplates,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Templates', path: '/service-provider/manage/templates' },
      { title: 'Create', path: '/service-provider/manage/templates/create-new' },
    ],
    exact: true,
    path: '/service-provider/manage/templates/create-new',
    component: AsyncSPTemplateDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Templates', path: '/service-provider/manage/templates' },
      { title: 'Edit', path: '/service-provider/manage/templates/:templateId' },
    ],
    exact: true,
    path: '/service-provider/manage/templates/:templateId',
    component: AsyncSPTemplateDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards',
    component: AsyncDashboards,
  },
  // IB-1899 Reporting requirements
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reporting Requirements', path: '/service-provider/manage/reporting-requirements' },
    ],
    exact: true,
    path: '/service-provider/manage/reporting-requirements',
    component: AsyncReportingRequirements,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reporting Requirements', path: '/service-provider/manage/reporting-requirements' },
      { title: 'Requirement', path: '/service-provider/manage/reporting-requirements/:requirementId' },
    ],
    exact: true,
    path: '/service-provider/manage/reporting-requirements/:requirementId',
    component: AsyncReportingRequirementDetail,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Workspace', path: '/service-provider/manage/dashboards/workspace/:workspaceId' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/workspace/:workspaceId',
    component: AsyncDashboards,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Workspace', path: '/service-provider/manage/dashboards/workspace/:workspaceId' },
      {
        title: 'Dashboard',
        path: '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId',
      },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId',
    component: AsyncDashboardsDashboard,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Workspace', path: '/service-provider/manage/dashboards/workspace/:workspaceId' },
      {
        title: 'Users',
        path: '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users',
      },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/workspace/:workspaceId/:dashboardId/users',
    component: AsyncDashboardsUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Metabase', path: '/service-provider/manage/dashboards/metabase' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/metabase',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Metabase', path: '/service-provider/manage/dashboards/metabase/:type/:id' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/metabase/:type/:id',
    component: AsyncDashboardsMetabase,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Create', path: '/service-provider/manage/dashboards/layout/create-new' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/layout/create-new',
    component: AsyncNewDashboardLayout,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Dashboards', path: '/service-provider/manage/dashboards' },
      { title: 'Edit', path: '/service-provider/manage/dashboards/layout/:layoutId' },
    ],
    exact: true,
    path: '/service-provider/manage/dashboards/layout/:layoutId',
    component: AsyncNewDashboardLayout,
  },

  // Admin Team Member routes
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Team Members', path: `${root.teamMember}` },
    ],
    exact: true,
    path: `${root.teamMember}`,
    component: AsyncTeamMembers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Team Members', path: `${root.teamMember}` },
      { title: 'Create', path: `${root.teamMember}/create-new` },
    ],
    exact: true,
    path: `${root.teamMember}/create-new`,
    component: AsyncTeamMembersCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Team Members', path: `${root.teamMember}` },
      { title: 'Edit', path: `${root.teamMember}/:teamMemberId` },
    ],
    exact: true,
    path: `${root.teamMember}/:teamMemberId`,
    component: AsyncTeamMembersCreate,
  },

  // Admin Team Member Activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Team', path: `${root.teamMember}` },
      { title: 'Activities', path: `${root.teamMemberActivities}` },
    ],
    exact: true,
    path: `${root.teamMemberActivities}`,
    component: AsyncActivitiesDetails,
  },

  // Admin Team Member Activity Sessions
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Sessions', path: `${root.teamMemberActivitySessions}` },
    ],
    exact: true,
    path: `${root.teamMemberActivitySessions}`,
    component: AsyncActivitiesSessions,
  },

  // Admin Create Session
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Sessions', path: `${root.teamMemberActivitySessions}/create` },
    ],
    exact: true,
    path: `${root.teamMemberActivitySessions}/create`,
    component: AsyncActivitiesSessionsCreate,
  },

  // Admin Edit Session
  {
    breadcrumbs: [
      { title: 'Create new session', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/activities' },
      { title: 'Team', path: '/service-provider/activities/:stakeholderId' },
      { title: 'Sessions', path: '/service-provider/activities/:activityId/sessions' },
      { title: 'Sessions', path: '/service-provider/activities/:activityId/sessions/:sessionId' },
    ],
    exact: true,
    path: `${root.teamMemberActivitySessions}/:sessionId`,
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Activities', path: '/service-provider/my-activities' },
    ],
    exact: true,
    path: '/service-provider/my-activities',
    component: AsyncActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/my-activities' },
      { title: 'Attendees', path: '/service-provider/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/service-provider/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/my-activities' },
      { title: 'Attendees', path: '/service-provider/my-activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/service-provider/my-activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/my-activities' },
      { title: 'Sessions', path: '/service-provider/my-activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/service-provider/my-activities/:activityId/sessions/',
    component: AsyncActivitiesSessions,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/my-activities' },
      { title: 'Sessions', path: '/service-provider/my-activities/:activityId/sessions/' },
      { title: 'Create Session', path: '/service-provider/my-activities/:activityId/sessions/create' },
    ],
    exact: true,
    path: '/service-provider/my-activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/my-activities' },
      { title: 'Sessions', path: '/service-provider/my-activities/:activityId/sessions/' },
      {
        title: 'Update Session',
        path: '/service-provider/my-activities/:activityId/sessions/:sessionId',
      },
    ],
    exact: true,
    path: '/service-provider/my-activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/activities' },
      { title: 'Activity', path: '/service-provider/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/service-provider/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },

  // manage activities
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Activities', path: '/service-provider/manage/activities' },
    ],
    exact: true,
    path: '/service-provider/manage/activities',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Groups', path: '/service-provider/manage/groups' },
    ],
    exact: true,
    path: '/service-provider/manage/groups',
    component: AsyncManageActivitiesDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Groups', path: '/service-provider/manage/groups' },
      { title: 'Options', path: '/service-provider/manage/groups/:groupId/options' },
    ],
    exact: true,
    path: '/service-provider/manage/groups/:groupId/options',
    component: AsyncManageGroupOptions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Services', path: '/service-provider/manage/services' },
    ],
    exact: true,
    path: '/service-provider/manage/services',
    component: AsyncManageActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Attendees', path: '/service-provider/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Attendees', path: '/service-provider/manage/activities/:activityId/attendees/' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/attendees/',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Sessions', path: '/service-provider/manage/activities/:activityId/sessions/' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/sessions/',
    component: AsyncManageActivitiesDetails,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Sessions', path: '/service-provider/manage/activities/:activityId/sessions/' },
      {
        title: 'Create Session',
        path: '/service-provider/manage/activities/:activityId/sessions/create',
      },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/sessions/create',
    component: AsyncActivitiesSessionsCreate,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Sessions', path: '/service-provider/manage/activities/:activityId/sessions/' },
      {
        title: 'Update Session',
        path: '/service-provider/manage/activities/:activityId/sessions/:sessionId',
      },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/sessions/:sessionId',
    component: AsyncActivitiesSessionsCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Activity', path: '/service-provider/manage/activities/activity/:activityId' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/activity/:activityId',
    component: AsyncActivitiesAttendees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Create', path: '/service-provider/manage/activities/create' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/create',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Edit', path: '/service-provider/manage/activities/:activityId' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId',
    component: AsyncActivityForm,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Activities', path: '/service-provider/manage/activities' },
      { title: 'Assign Users', path: '/service-provider/manage/activities/:activityId/assign-users' },
    ],
    exact: true,
    path: '/service-provider/manage/activities/:activityId/assign-users',
    component: AsyncActivityAssignUsers,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Indicators', path: '/service-provider/manage/indicatorFrameworks' },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks',
    component: AsyncIndicatorFrameworks,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Periods',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods',
    component: AsyncIndicatorPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Indicators',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators',
      },
      {
        title: 'Edit',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId',
    component: AsyncIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Monitoring',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring',
    component: AsyncIndicatorFrameworkMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Reporters',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters',
    component: AsyncIndicatorFrameworkReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      {
        title: 'Reporters',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters',
      },
      {
        title: 'Assignees',
        path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees',
    component: AsyncIndicatorFrameworkReportersAssignees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/service-provider/manage/indicatorFrameworks/period-groups' },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      { title: 'PeriodGroups', path: '/service-provider/manage/indicatorFrameworks/period-groups' },
      {
        title: 'Periods',
        path: '/service-provider/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'PeriodGroups', path: '/service-provider/programmes/period-groups' },
    ],
    exact: true,
    path: '/service-provider/programmes/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'PeriodGroups', path: '/service-provider/programmes/period-groups' },
      { title: 'Periods', path: '/service-provider/programmes/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/service-provider/programmes/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Interventions', path: '/service-provider/interventions' },
      { title: 'PeriodGroups', path: '/service-provider/interventions/period-groups' },
    ],
    exact: true,
    path: '/service-provider/interventions/period-groups',
    component: AsyncIndicatorFrameworkPeriodGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Interventions', path: '/service-provider/interventions' },
      { title: 'PeriodGroups', path: '/service-provider/interventions/period-groups' },
      { title: 'Periods', path: '/service-provider/interventions/period-groups/:periodGroupId/periods' },
    ],
    exact: true,
    path: '/service-provider/interventions/period-groups/:periodGroupId/periods',
    component: AsyncIndicatorFrameworkPeriodGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Interventions', path: '/service-provider/interventions' },
      { title: 'CurrencyGroups', path: '/service-provider/interventions/currency-groups' },
    ],
    exact: true,
    path: '/service-provider/interventions/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'CurrencyGroups', path: '/service-provider/programmes/currency-groups' },
    ],
    exact: true,
    path: '/service-provider/programmes/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'CurrencyGroups', path: '/service-provider/programmes/currency-groups' },
      { title: 'Periods', path: '/service-provider/programmes/currency-groups/:currencyGroupId/periods' },
    ],
    exact: true,
    path: '/service-provider/programmes/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/service-provider/manage/indicatorFrameworks/currency-groups' },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/currency-groups',
    component: AsyncIndicatorFrameworkCurrencyGroups,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'IndicatorFrameworks', path: '/service-provider/manage/indicatorFrameworks' },
      { title: 'CurrencyGroups', path: '/service-provider/manage/indicatorFrameworks/currency-groups' },
      {
        title: 'Periods',
        path: '/service-provider/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods',
      },
    ],
    exact: true,
    path: '/service-provider/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods',
    component: AsyncIndicatorFrameworkCurrencyGroupPeriods,
  },
  // exports
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Data Exports', path: '/service-provider/exports' },
    ],
    exact: true,
    path: '/service-provider/exports',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Data Exports', path: '/service-provider/exports' },
      { title: 'Questions', path: '/service-provider/exports/:workspaceId/questions' },
    ],
    exact: true,
    path: '/service-provider/exports/:workspaceId/questions',
    component: AsyncMetabaseDataExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Data Exports', path: '/service-provider/exports' },
      { title: 'Questions', path: '/service-provider/exports/:workspaceId/questions' },
      { title: 'Question', path: '/service-provider/exports/:workspaceId/questions/:type/:typeId' },
    ],
    exact: true,
    path: '/service-provider/exports/:workspaceId/questions/:type/:typeId',
    component: AsyncMetabaseDataExportQuestion,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Profile Data', path: '/service-provider/exports/profile-data' },
    ],
    exact: true,
    path: '/service-provider/exports/profile-data',
    component: AsyncExport,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programme Stats', path: '/service-provider/exports/programme-stats' },
    ],
    exact: true,
    path: '/service-provider/exports/programme-stats',
    component: AsyncProgrammeStats,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'School Data Exports', path: '/service-provider/exports/school-data' },
    ],
    exact: true,
    path: '/service-provider/exports/school-data',
    component: AsyncMetabaseDataExport,
  },

  // reports
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
    ],
    exact: true,
    path: '/service-provider/reports',
    component: AsyncReports,
  },
  // IB-1899: periods owed by this organisation (Reports > Requirements)
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Requirements', path: '/service-provider/reports/requirements' },
    ],
    exact: true,
    path: '/service-provider/reports/requirements',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/create' },
    ],
    exact: true,
    path: '/service-provider/reports/create',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/create-link' },
    ],
    exact: true,
    path: '/service-provider/reports/create-link',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/create-report' },
    ],
    exact: true,
    path: '/service-provider/reports/create-report',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/create-template' },
    ],
    exact: true,
    path: '/service-provider/reports/create-template',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/templates' },
    ],
    exact: true,
    path: '/service-provider/reports/templates',
    component: AsyncReports,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Create', path: '/service-provider/reports/templates/:templateId' },
    ],
    exact: true,
    path: '/service-provider/reports/templates/:templateId',
    component: AsyncReportDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Reports', path: '/service-provider/reports' },
      { title: 'Edit', path: '/service-provider/reports/:reportId' },
    ],
    exact: true,
    path: '/service-provider/reports/:reportId',
    component: AsyncReportDetails,
  },
  // manage programmes
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
    ],
    exact: true,
    path: '/service-provider/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Portfolios', path: '/service-provider/programmes/portfolios', key: 'Portfolios-tab' },
    ],
    exact: true,
    path: '/service-provider/programmes/portfolios',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes', key: 'Programmes-tab' },
    ],
    exact: true,
    path: '/service-provider/programmes',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Create', path: '/service-provider/programmes/create' },
    ],
    exact: true,
    path: '/service-provider/programmes/create',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Overview', path: '/service-provider/programmes/:programmeId/overview' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/overview',
    component: AsyncProgrammeOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Indicators', path: '/service-provider/programmes/:programmeId/indicators' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/indicators',
    component: AsyncProgrammeIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Monitoring', path: '/service-provider/programmes/:programmeId/monitoring' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/monitoring',
    component: AsyncProgrammeMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Complete', path: '/service-provider/programmes/:programmeId/complete' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/complete',
    component: AsyncProgrammeComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites',
    component: AsyncProgrammeSites,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/service-provider/programmes/:programmeId/sites/hierarchies' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/hierarchies',
    component: AsyncProgrammeHierarchies,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/service-provider/programmes/:programmeId/sites/hierarchies' },
      { title: 'Hierarchy', path: '/service-provider/programmes/:programmeId/sites/hierarchies/:hierarchyId' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/hierarchies/:hierarchyId',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Hierarchies', path: '/service-provider/programmes/:programmeId/sites/hierarchies' },
      { title: 'Create', path: '/service-provider/programmes/:programmeId/sites/hierarchies/create' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/hierarchies/create',
    component: AsyncProgrammeHierarchy,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Services', path: '/service-provider/programmes/:programmeId/sites/services' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/services',
    component: AsyncProgrammeServices,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Services', path: '/service-provider/programmes/:programmeId/sites/services' },
      { title: 'Service', path: '/service-provider/programmes/:programmeId/sites/services/:serviceId' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/services/:serviceId',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Sites', path: '/service-provider/programmes/:programmeId/sites' },
      { title: 'Services', path: '/service-provider/programmes/:programmeId/sites/services' },
      { title: 'Create', path: '/service-provider/programmes/:programmeId/sites/services/create' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/sites/services/create',
    component: AsyncProgrammeService,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Reporters', path: '/service-provider/programmes/:programmeId/reporters' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/reporters',
    component: AsyncProgrammeReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Reporters', path: '/service-provider/programmes/:programmeId/reporters' },
      { title: 'Assignees', path: '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees' },
    ],
    exact: true,
    path: '/service-provider/programmes/:programmeId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions',
    component: AsyncProgramme,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Create', path: '/service-provider/programmes/interventions/create' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/create',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Overview', path: '/service-provider/programmes/interventions/:interventionId/overview' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/overview',
    component: AsyncInterventionOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Inputs', path: '/service-provider/programmes/interventions/:interventionId/inputs' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/inputs',
    component: AsyncInterventionInputs,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Indicators',
        path: '/service-provider/programmes/interventions/:interventionId/indicators',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/indicators',
    component: AsyncInterventionIndicators,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Activities',
        path: '/service-provider/programmes/interventions/:interventionId/activities',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/activities',
    component: AsyncInterventionActivities,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Monitoring',
        path: '/service-provider/programmes/interventions/:interventionId/monitoring',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/monitoring',
    component: AsyncInterventionMonitoring,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Complete', path: '/service-provider/programmes/interventions/:interventionId/complete' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/complete',
    component: AsyncInterventionComplete,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/stakeholders',
    component: AsyncInterventionStakeholders,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts',
    component: AsyncInterventionStakeholderCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
      {
        title: 'Create',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/create',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/create',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Stakeholders',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts',
      },
      {
        title: 'Create',
        path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId',
    component: AsyncInterventionStakeholderCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/service-provider/programmes/interventions/:interventionId/institutions',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/institutions',
    component: AsyncInterventionInstitutions,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/service-provider/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts',
    component: AsyncInterventionInstitutionCohorts,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/service-provider/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts',
      },
      {
        title: 'Create',
        path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/create',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/create',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      {
        title: 'Institutions',
        path: '/service-provider/programmes/interventions/:interventionId/institutions',
      },
      {
        title: 'Cohorts',
        path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts',
      },
      {
        title: 'Create',
        path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/institutions/cohorts/:cohortId',
    component: AsyncInterventionInstitutionCohortDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Reporters', path: '/service-provider/programmes/interventions/:interventionId/reporters' },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/reporters',
    component: AsyncProgrammeReporters,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Programmes', path: '/service-provider/programmes' },
      { title: 'Interventions', path: '/service-provider/programmes/interventions' },
      { title: 'Reporters', path: '/service-provider/programmes/interventions/:interventionId/reporters' },
      {
        title: 'Assignees',
        path: '/service-provider/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
      },
    ],
    exact: true,
    path: '/service-provider/programmes/interventions/:interventionId/reporters/:reporterId/assignees',
    component: AsyncProgrammeReporterAssignees,
  },
  // Insights
  // Manage Insights
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      {
        title: 'Insights',
        path: '/service-provider/manage/insights',
      },
    ],
    exact: true,
    path: '/service-provider/manage/insights',
    component: AsyncManageInsights,
  },
  // Create Insight
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Insight', path: '/service-provider/manage/insights' },
    ],
    exact: true,
    path: '/service-provider/manage/insights/create-new',
    component: AsyncInsightsDetails,
  },
  // Update Insight
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Insight', path: '/service-provider/manage/insights' },
    ],
    exact: true,
    path: '/service-provider/manage/insights/:insightId',
    component: AsyncInsightsDetails,
  },
  // Insight Users
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Insight', path: '/service-provider/manage/insights' },
      { title: 'Users', path: '/service-provider/manage/insights/:insightId/users' },
    ],
    exact: true,
    path: '/service-provider/manage/insights/:insightId/users',
    component: AsyncInsightUsers,
  },
  //Admin
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Admin', path: '/service-provider/admin' },
    ],
    exact: true,
    path: '/service-provider/admin',
    component: AsyncAdminPage,
  },
  // Account Details - a service provider managing its own profile
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Admin', path: '/service-provider/admin' },
      { title: 'Account Details', path: '/service-provider/account' },
    ],
    exact: true,
    path: '/service-provider/account',
    component: AsyncAccountDetails,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      { title: 'Create', path: '/service-provider/admin/workspaces/create-new' },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      { title: 'Edit', path: '/service-provider/admin/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      { title: 'Overview', path: '/service-provider/admin/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      {
        title: 'Dataset',
        path: '/service-provider/admin/workspaces/:workspaceId/overview/datasets/create-new',
      },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      {
        title: 'Dataset',
        path: '/service-provider/admin/workspaces/:workspaceId/overview/datasets/:datasetId',
      },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      {
        title: 'Form',
        path: '/service-provider/admin/workspaces/:workspaceId/overview/forms/create-new',
      },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/admin/workspaces' },
      { title: 'Form', path: '/service-provider/admin/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/service-provider/admin/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Templates', path: '/service-provider/admin/templates' },
    ],
    exact: true,
    path: '/service-provider/admin/templates',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Modules', path: '/service-provider/admin/modules' },
    ],
    exact: true,
    path: '/service-provider/admin/modules',
    component: AsyncAdminModules,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Audit Trail', path: '/service-provider/admin/audittrail' },
    ],
    exact: true,
    path: '/service-provider/admin/audittrail',
    component: AsyncAdminAuditTrail,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Organisations', path: '/service-provider/admin/organisations' },
    ],
    exact: true,
    path: '/service-provider/admin/organisations',
    component: AsyncAdminOrganisations,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Organisations', path: '/service-provider/admin/organisations' },
      { title: 'Users', path: '/service-provider/admin/organisations/:organisationId/users' },
    ],
    exact: true,
    path: '/service-provider/admin/organisations/:organisationId/users',
    component: AsyncAdminOrganisationsUsers,
  },

  // My Forms
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
    ],
    exact: true,
    path: '/service-provider/my-forms',
    component: AsyncMyFormsPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
      { title: 'Submissions', path: '/service-provider/my-forms/:id/submissions' },
    ],
    exact: true,
    path: '/service-provider/my-forms/:id/submissions',
    component: AsyncMyFormsPage,
  },
  //submission
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
      { title: 'Submissions', path: '/service-provider/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/service-provider/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions/submit' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/submit',
    component: AsyncMyFormsCreateSubmission,
  },

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
      { title: 'Submissions', path: '/service-provider/my-forms/:id/submissions/:submissionId' },
    ],
    exact: true,
    path: '/service-provider/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
      { title: 'Calculate', path: '/service-provider/my-forms/:id/submissions/:submissionId/calculate' },
    ],
    exact: true,
    path: '/service-provider/my-forms/:id/submissions/:submissionId/calculate',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/service-provider/my-forms' },
      {
        title: 'Calculate',
        path: '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber',
      },
    ],
    exact: true,
    path: '/service-provider/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber',
    component: AsyncMyFormsSubmissionCalculate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'My Forms', path: '/my-forms' },
      { title: 'Submissions', path: '/my-forms/:id/submissions' },
    ],
    exact: true,
    path: '/my-forms/:id/submissions/:submissionId',
    component: AsyncMyFormsSubmissionPage,
  },
  // Manage Forms
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/service-provider' },
  //     { title: 'Forms', path: '/service-provider/manage/my-forms' },
  //   ],
  //   exact: true,
  //   path: '/service-provider/manage/my-forms',
  //   component: AsyncMyFormsPage,
  // },
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/service-provider' },
  //     { title: 'Forms', path: '/service-provider/manage/my-forms' },
  //     { title: 'Submissions', path: '/service-provider/manage/forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/service-provider/manage/my-forms/:id/submissions',
  //   component: AsyncMyFormsPage,
  // },
  // //submission
  // {
  //   breadcrumbs: [
  //     { title: 'Home', path: '/service-provider' },
  //     { title: 'Forms', path: '/service-provider/manage/my-forms' },
  //     { title: 'Submissions', path: '/service-provider/manage/my-forms/:id/submissions' },
  //   ],
  //   exact: true,
  //   path: '/service-provider/manage/my-forms/:id/submissions/:submissionId',
  //   component: AsyncMyFormsSubmissionPage,
  // },

  // Manage Forms

  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces',
    component: AllWorkspaces,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      { title: 'Create', path: '/service-provider/manage/workspaces/create-new' },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/create-new',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      { title: 'Edit', path: '/service-provider/manage/workspaces/:workspaceId' },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId',
    component: AsyncAdminWorkspaceCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      { title: 'Overview', path: '/service-provider/manage/workspaces/:workspaceId/overview' },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId/overview',
    component: AsyncAdminWorkspaceOverview,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      {
        title: 'Dataset',
        path: '/service-provider/manage/workspaces/:workspaceId/overview/datasets/create-new',
      },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId/overview/datasets/create-new',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      {
        title: 'Dataset',
        path: '/service-provider/manage/workspaces/:workspaceId/overview/datasets/:datasetId',
      },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId/overview/datasets/:datasetId',
    component: AsyncAdminWorkspaceDatasetCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      {
        title: 'Form',
        path: '/service-provider/manage/workspaces/:workspaceId/overview/forms/create-new',
      },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId/overview/forms/create-new',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Workspaces', path: '/service-provider/manage/workspaces' },
      { title: 'Form', path: '/service-provider/manage/workspaces/:workspaceId/overview/forms/:formId' },
    ],
    exact: true,
    path: '/service-provider/manage/workspaces/:workspaceId/overview/forms/:formId',
    component: AsyncAdminWorkspaceFormCreate,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Appointments', path: '/service-provider/manage/cases/appointments' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/appointments',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
    ],
    exact: true,
    path: '/service-provider/manage/cases',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Consultations', path: '/service-provider/manage/cases/consultations' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/consultations',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Medication Queue', path: '/service-provider/manage/cases/medication-queue' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/medication-queue',
    component: AsyncMyCases,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case Management', path: '/service-provider/manage/cases/case-management' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/case-management',
    component: AsyncCaseManagement,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case Management', path: '/service-provider/manage/cases/case-management' },
      { title: 'Configure', path: '/service-provider/manage/cases/case-management/activities/:activityId/configure' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/case-management/activities/:activityId/configure',
    component: AsyncConfigureSession,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case Management', path: '/service-provider/manage/cases/case-management' },
      { title: 'Case ID', path: '/service-provider/manage/cases/case-management/case-id-configuration' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/case-management/case-id-configuration',
    component: AsyncCaseIdConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case Management', path: '/service-provider/manage/cases/case-management' },
      { title: 'Case Details', path: '/service-provider/manage/cases/case-management/case-details-configuration' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/case-management/case-details-configuration',
    component: AsyncCaseDetailsConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case Management', path: '/service-provider/manage/cases/case-management' },
      { title: 'Case Summary', path: '/service-provider/manage/cases/case-management/case-summary-configuration' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/case-management/case-summary-configuration',
    component: AsyncCaseSummaryConfiguration,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Consultations', path: '/service-provider/manage/cases/consultations' },
      { title: 'Consultation', path: '/service-provider/manage/cases/consultations/:consultationId' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/consultations/:consultationId',
    component: AsyncConsultationPage,
  },
  {
    breadcrumbs: [
      { title: 'Home', path: '/service-provider' },
      { title: 'Cases', path: '/service-provider/manage/cases' },
      { title: 'Case', path: '/service-provider/manage/cases/:caseId' },
    ],
    exact: true,
    path: '/service-provider/manage/cases/:caseId',
    component: AsyncClientPage,
  },
];
